export default class DtoCmsModelObstacle {
    constructor(obj) {
        this.modelId = obj.modelId
        this.obstacleId = obj.obstacleId
        this.installationCode = obj.installationCode
        this.defaultValue = obj.defaultValue
        this.order = obj.order
    }
}
